import { render } from "./ControlCenter.vue?vue&type=template&id=256099ac&scoped=true"
import script from "./ControlCenter.vue?vue&type=script&language=ts&lang=js"
export * from "./ControlCenter.vue?vue&type=script&language=ts&lang=js"

import "./ControlCenter.vue?vue&type=style&index=0&id=256099ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-256099ac"

export default script